// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--sYOJn";
export var card = "styles-module--card--ClleP";
export var title = "styles-module--title--jipVr";
export var text = "styles-module--text--ykgEl";
export var metadata = "styles-module--metadata--ZrQN3";
export var subtitle = "styles-module--subtitle--YFtPW";
export var authors = "styles-module--authors--yu6XS";
export var image = "styles-module--image--AFmE4";